export const typeOfConstructionSchema = {
	schema: {
		title: 'type of construction schema',
		description: 'Type of Construction Schema',
		version: 0,
		primaryKey: 'code',
		type: 'object',
		properties: {
			code: {
				type: 'string',
				maxLength: 250,
			},
			name: {
				type: 'string',
			},
			image: {
				type: 'string',
			},
			sub_classifications: {
				type: 'array',
				items: {
					type: 'object',
					properties: {
						code: { type: 'string' },
						name: { type: 'string' },
						image: { type: 'string' },
					},
				},
			},
		},
		required: ['code', 'name', 'image', 'sub_classifications'],
	},
};
